module.exports = __webpack_public_path__ + "img/candy1.462ee414.png";